import ConfigModel from "./ConfigModel"
import UserModel from "./UserModel"

export default class FeedbackModel {
  configModel
  userModel

  constructor() {
    this.configModel = new ConfigModel()
    this.userModel = new UserModel()
  }

  // Get existing feedback from the database
  async GetFeedback() {
    let url = `${this.configModel.api}get_feedback`
    let data = {
      access_key: "8525", 
    }
    let userData = this.userModel.GetUserFromLocal()
    let authorization = userData.data.api_token

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authorization}`,
        },
        body: JSON.stringify(data),
      })

      const response_data = await response.json()
      return response_data
    } catch (err) {
      console.error("Error fetching feedback: ", err)
      return err
    }
  }

  // Submit feedback to the database
  async SubmitFeedback(name, email, feedback, rating) {
    let url = `${this.configModel.api}submit_feedback`
    let data = {
      access_key: "8525", // You can use a dynamic value here if needed
      name: name,
      email: email,
      feedback: feedback,
      rating: rating,
    }
    let userData = this.userModel.GetUserFromLocal()
    let authorization = userData.data.api_token

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authorization}`,
        },
        body: JSON.stringify(data),
      })

      const response_data = await response.json()
      return response_data
    } catch (err) {
      console.error("Error submitting feedback: ", err)
      return err
    }
  }

   // Optionally, you can add other methods related to feedback, such as updating or deleting feedback
}
